exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headImg[data-v-3a30bd5b]{overflow:hidden;width:100px;height:100px;margin:10px auto;border-radius:50%}.headImg img[data-v-3a30bd5b]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3a30bd5b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/Setting.vue
// module id = 430
// module chunks = 0